export const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleString('ru', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    })

    return date.replace(' г. в', ',')
};
